export default "__VITE_ASSET__DXi6OEM9__"